const backendUrl = process.env.REACT_APP_BACKEND_URL;

if (!backendUrl) throw new Error("REACT_APP_BACKEND_URL est requis");

export const BACKEND_URL = backendUrl.replace(/\/$/, "");
